import React from "react";
import {
  FormControl,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { AddButton } from "../../../utils/Custom/Button";
import { ClassicTable } from "../clientMaster/ClassicTable";
import Text from "../../../utils/Custom/text";
import { DateInput, TextFields } from "../../../utils/Custom/custominput";

const CommonTableIR = ({
  headers,
  rows,
  onChange,
  onDeleteRow,
  onAddRow,
  label,
  headingLabel,
  PrintView
}) => {
  return (
    <>
      <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3 mb-5">
        {headingLabel}
      </Text>

      {!PrintView && (
      <div className="flex justify-end mb-3">
        <AddButton
          label={label}
          icon={<AddIcon fontSize="small" />}
          onClick={onAddRow}
        />
      </div>
      )}

      <div className="overflow-x-auto">
      <ClassicTable>
        <Table sx={{ minWidth: 660 }}>
          <TableHead>
            <TableRow>
              <TableCell>Sr.No.</TableCell>
              {headers.map((col) => (
                <TableCell key={col.field}>{col.label}</TableCell>
              ))}
              {!PrintView && (
                <TableCell>Actions</TableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                <TableCell>{rowIndex + 1}</TableCell>
                {headers.map((col) => (
                  <TableCell key={col.field}>
                    {col.type === "date" ? (
                      <DateInput
                        id={`${col.field}-${rowIndex}`}
                        label={col.label}
                        value={row[col.field] || ""}
                        onChange={(newDate) => {
                          const formattedDate = newDate;
                          onChange(rowIndex, col.field, formattedDate);
                        }}
                        disabled={PrintView}
                      />
                    ) : col.type === "select" ? (
                      <FormControl size="small" fullWidth disabled={PrintView}>
                        <Select
                          value={row[col.field] ?? 0}
                          onChange={(e) => onChange(rowIndex, col.field, e.target.value)}
                          displayEmpty
                          renderValue={(val) => {
                            const found = col.options?.find((o) => o.value === val);
                            return (
                              <span style={{ color: val === 0 ? "#9ca3af" : "inherit" }}>
                                {found ? found.label : "Select"}
                              </span>
                            );
                          }}
                          sx={{ backgroundColor: "#fff", fontSize: "0.875rem" }}
                        >
                          {col.options?.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value} disabled={opt.value === 0}>
                              {opt.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    ) : (
                      <TextFields
                        label={col.label}
                        value={row[col.field] || ""}
                        onChange={(e) =>
                          onChange(rowIndex, col.field, e.target.value)
                        }
                        multiline
                        minRows={1}
                        maxRows={10}
                        disabled={PrintView}
                      />
                    )}
                  </TableCell>
                ))}
                {!PrintView && (
                <TableCell>
                  <DeleteIcon
                    style={{ color: "#dc3545", cursor: "pointer" }}
                    onClick={() => onDeleteRow(rowIndex)}
                  />
                </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ClassicTable>
      </div>
    </>
  );
};

export default CommonTableIR;
